import { getFileTypeFromFileName } from '@office-start/file-utility';
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logFeature } from '@office-start/telemetry-service';
import { UploadResult } from '../models/UploadResult';
import { getCommonTelemetryParams } from './getCommonTelemetryParams';
export function logFeatureForUploadHelper(sessionId, uploadResult, uploadStartTime, fileUploadState) {
    var _a, _b, _c;
    var _d = fileUploadState.telemetry, source = _d.source, version = _d.version, area = _d.area;
    var params = getCommonTelemetryParams(source, version);
    params["UploadSessionId" /* InstrumentationParam.UploadSessionId */] = sessionId;
    params["TotalSize" /* InstrumentationParam.TotalSize */] =
        (_a = fileUploadState === null || fileUploadState === void 0 ? void 0 : fileUploadState.file) === null || _a === void 0 ? void 0 : _a.size.toString();
    params["DocumentType" /* InstrumentationParam.DocumentType */] = getFileTypeFromFileName((_c = (_b = fileUploadState.file) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '');
    params["Area" /* InstrumentationParam.Area */] = area;
    params["IsUploadSuccessful" /* InstrumentationParam.IsUploadSuccessful */] =
        uploadResult === UploadResult.Success ? true : false;
    if (uploadResult === UploadResult.Cancelled) {
        params["IsUploadCancelled" /* InstrumentationParam.IsUploadCancelled */] = true;
    }
    // Log telemetry for Upload Completed
    params["Latency" /* InstrumentationParam.Latency */] = Math.ceil(performance.now() - uploadStartTime).toString();
    logGenericEvent(KnownInstrumentationEvents.UploadCompleted, params, [
        KnownInstrumentationEvents.UploadCompleted,
    ]);
    logFeature({
        featureName: "Upload" /* KnownFeatureNames.Upload */,
        eventName: "Upload_Completed" /* KnownFeatureInstrumentationEvents.UploadCompleted */,
        params: params,
    });
}
//# sourceMappingURL=logFeatureForUploadHelper.js.map